import { FaDownload } from '@meronex/icons/fa';
import React from 'react';
import { Box, Link } from '@apia/theme';
import { downloadUrl } from '../../../../../utils/util';
import {
  TAccordionCellRenderer,
  TAccordionCellRendererProps,
} from './AccordionCell';

export type TDocNameCellRendererProps = {
  docName: string;
  docUrl: string;
};

export type TDocNameCellRenderer =
  TAccordionCellRendererProps<TDocNameCellRendererProps>;

const AccordionDocNameCellRenderer: TAccordionCellRenderer<TDocNameCellRendererProps> =
  React.forwardRef<HTMLElement, TDocNameCellRenderer>(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
      },
      currentRef,
    ) => (
      <Box ref={currentRef as React.RefObject<HTMLElement>} {...cell}>
        <Box as="strong">{column.label ?? column.name}: </Box>
        <Link
          className="cell__download__document"
          title={rendererProps?.docName}
          href={rendererProps?.docUrl}
          onClick={(ev) => {
            ev.preventDefault();
            if (rendererProps?.docUrl) void downloadUrl(rendererProps?.docUrl);
          }}
        >
          <FaDownload />
          {rendererProps?.docName}
        </Link>
      </Box>
    ),
  );

export default AccordionDocNameCellRenderer;
